import { render, staticRenderFns } from "./AddCryptoAccount.vue?vue&type=template&id=fdbca2a2&scoped=true"
import script from "./AddCryptoAccount.vue?vue&type=script&lang=js"
export * from "./AddCryptoAccount.vue?vue&type=script&lang=js"
import style0 from "./AddCryptoAccount.vue?vue&type=style&index=0&id=fdbca2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbca2a2",
  null
  
)

export default component.exports